
	import Vue from 'vue';
	import Component from 'vue-class-component';
	import { LocalStorageEnum } from '@/types/enum/LocalStorageEnum';

	declare const BFF_URL: string;
	declare const FC_ACTIVE: string;
	const Props = Vue.extend({
		props: {
			title: {
				type: String,
				required: true
			}
		}
	});

	@Component
	export default class LayoutConnexionInscriptionAssure extends Props {
		link = BFF_URL + '/fc/login';

		get isFCActive(): boolean {
			return FC_ACTIVE === 'true';
		}

		get colsLine(): string {
			return this.$vuetify.breakpoint.smAndDown ? '12' : 'auto ml-10 mr-10';
		}

		get line(): string {
			return this.$vuetify.breakpoint.smAndDown ? 'line-h' : 'line-v';
		}

		get lineDirection(): string {
			const classLine = 'd-flex align-center justify-space-evenly ';
			if (this.$vuetify.breakpoint.mdAndUp) {
				return classLine + ' flex-column';
			}
			return classLine;
		}

		mounted(): void {
			if (localStorage.getItem(LocalStorageEnum.CONFIRMATION_EMAIL_POP_UP)) {
				localStorage.removeItem(LocalStorageEnum.CONFIRMATION_EMAIL_POP_UP);
			}
		}

		confirmationEmailPopUp(event: Event): void {
			if (event.target.href !== 'https://franceconnect.gouv.fr/') {
				localStorage.setItem(LocalStorageEnum.CONFIRMATION_EMAIL_POP_UP, 'true');
			}
		}
	}
